import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** @jsx jsx */


import { jsx } from 'theme-ui';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Zoom = function Zoom(_ref) {
  var ratio = _ref.ratio,
      _ref$zoom = _ref.zoom,
      zoom = _ref$zoom === void 0 ? 1 : _ref$zoom,
      props = _objectWithoutPropertiesLoose(_ref, ["ratio", "zoom"]);

  return jsx("div", {
    sx: {
      boxSizing: 'border-box',
      width: '100%',
      position: 'relative',
      height: ratio ? 0 : '100%',
      pb: ratio ? 1 / ratio * 100 + "%" : 0
    }
  }, jsx("div", _extends({}, props, {
    sx: {
      boxSizing: 'border-box',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      bg: 'cyan',
      width: 1 / zoom * 100 + "%",
      height: 1 / zoom * 100 + "%",
      transformOrigin: '0 0',
      transform: "scale(" + zoom + ")"
    }
  })));
};
export default Zoom;